'use strict';
const angular = require('angular');
import { Ids as ACTION_IDS } from '../components/constants/action.constants';

let removeToobarOptions = function (taOptions) {
    let toolsToRemove = ["pre", "quote", "html", "insertVideo", "wordcount", "charcount"];
    if (taOptions.toolbar && taOptions.toolbar.length) {
        for (let i = 0; i < toolsToRemove.length; i++) {
            for (let j = 0; j < taOptions.toolbar.length; j++) {
                let index = taOptions.toolbar[j].indexOf(toolsToRemove[i]);
                if (index > -1) {
                    taOptions.toolbar[j].splice(index, 1);
                }
            }
        }
    }
};

var adoddleWebURL = (<any>window).properties.service.asiteUrl;
var unauthorisedRedirect = function (response) {
    if (!response || !response.status) {
        return;
    }

    switch (response.status) {
        case 401:
            angular.element('body').hide();
            (<any>window).onbeforeunload = function () { };
            window.location.href = adoddleWebURL + "/unauthorised";
            break;
        case 403:
            window.localStorage.setItem('sessionState', 'Inactive');
            (<any>window).openLoginModal();
            /* angular.element('body').hide();
            (<any>window).onbeforeunload = function () {};
            window.location.href = adoddleWebURL + "/session-timed-out"; */
            break;
    }
};

export function routeConfig($urlRouterProvider, $locationProvider, $translateProvider, $provide, $httpProvider) {
    'ngInject';

    $urlRouterProvider
        .otherwise('/');

    $locationProvider.html5Mode(true);

    $translateProvider.preferredLanguage('en_GB');
    if ((<any>window).GLOBALS && (<any>window).GLOBALS.for !== 'Meta-Data') {
        $translateProvider.useLoader('customLoader');
    }
    angular.lowercase = angular.$$lowercase;
    angular.uppercase = angular.$$uppercase;

    $provide.factory('httpInterceptor', function ($q) {
        return {
            'response': function (response) {
                if (response.config.url.indexOf(ACTION_IDS.GET_SESSION_TIMEOUT_DETAILS) == -1) {
                    (<any>window).setsessionTimoutTimer && (<any>window).setsessionTimoutTimer();
                }
                unauthorisedRedirect(response);
                return response;
            },
            'responseError': function (rejection) {
                if (rejection.config.url.indexOf(ACTION_IDS.GET_SESSION_TIMEOUT_DETAILS) == -1) {
                    (<any>window).setsessionTimoutTimer && (<any>window).setsessionTimoutTimer();
                }
                unauthorisedRedirect(rejection);
                return $q.reject(rejection);
            }
        };
    });

    $httpProvider.interceptors.push('httpInterceptor');

    $provide.decorator('taToolFunctions', ['$delegate', function ($delegate) {
        // save original function to call it later
        var imgOnSelectActionFn = $delegate.imgOnSelectAction;

        // decorate imgOnSelectAction
        $delegate.imgOnSelectAction = function (event, $element, editorScope) {
            // call original function in which img toolbar is constructed
            imgOnSelectActionFn(event, $element, editorScope);

            // set popover size to fit content
            // btw, dunno why it is set to concrete size
            editorScope.displayElements.popover.css('width', 'auto');


            editorScope.displayElements.popover
                .find('.btn-group')
                // eq(0) -> [full, half, quart]
                // eq(1) -> [floatLeft, floatNone, floatRight]
                // eq(2) -> [remove]
                .eq(1).remove();
        };

        return $delegate;
    }]);
    $provide.decorator('taOptions', ['taRegisterTool', '$delegate', function (taRegisterTool, taOptions) {
        // $delegate is the taOptions we are decorating
        // register the tool with textAngular
        removeToobarOptions(taOptions);
        taRegisterTool('backgroundColor', {
            //display: "<div spectrum-colorpicker ng-model='color' on-change='!!color && action(color)' format='\"hex\"' options='options'></div>",
            display: "<div spectrum-colorpicker ng-model='color' on-change='!!color && action(color)' format='\"rgb\"' options='options'></div>",
            action: function (color) {
                var me = this;
                if (!this.$editor().wrapSelection) {
                    setTimeout(function () {
                        me.action(color);
                    }, 100)
                } else {
                    if(color!="rgb(255, 255, 255)" &&  color!="#fff" ) {
                        return this.$editor().wrapSelection('backColor', color);
                    }
                }
            },
            options: {
                replacerClassName: 'fa fa-paint-brush', showButtons: false, appendTo: ".drop-area"
            },
            color: "#fff"
        });
        taRegisterTool('fontColor', {
            display: "<spectrum-colorpicker trigger-id='{{trigger}}' ng-model='color' on-change='!!color && action(color)' format='\"hex\"' options='options'></spectrum-colorpicker>",
            action: function (color) {
                var me = this;
                if (!this.$editor().wrapSelection) {
                    setTimeout(function () {
                        me.action(color);
                    }, 100)
                } else {
                    if(color != '#000' && color != '#000000') {
                        return this.$editor().wrapSelection('foreColor', color);
                    }
                }
            },
            options: {
                replacerClassName: 'fa fa-font', showButtons: false, appendTo: ".drop-area", showAlpha : false
            },
            color: "#000"
        });
        taRegisterTool('fontName', {
            display: "<span class='bar-btn-dropdown dropdown' uib-dropdown style='padding:4px 10px; z-index:3'>" +
            "<button class='dropdown-toggle dropdown-toggle-btn' uib-dropdown-toggle type='button' ng-disabled='showHtml()'>Font-Family&nbsp;<i class='fa fa-caret-down'></i></button>" +
            "<ul class='dropdown-menu' uib-dropdown-menu aria-labelledby='dropdownMenu' style='max-height: 110px;overflow-x: scroll;'><li ng-repeat='o in options'><button class='checked-dropdown' style='font-family: {{o.css}}; width: 100%' type='button' ng-click='action($event, o.css)'><i ng-if='o.active' class='fa fa-check'></i>{{o.name}}</button></li></ul></span>",
            action: function (event, font) {
                //Ask if event is really an event.
                if (!!event.stopPropagation) {
                    //With this, you stop the event of textAngular.
                    event.stopPropagation();
                    //Then click in the body to close the dropdown.
                    $("body").trigger("click");
                }
                return this.$editor().wrapSelection('fontName', font);
            },
            options: [
            {name:'Arial', css:'Arial'}, 
            {name:'Helvetica', css:'Helvetica'},
            {name:'Times New Roman', css:'Times New Roman'}, 
            {name:'Times', css:'Times'},
            {name:'Courier New', css:'Courier New'}, 
            {name:'Courier', css:'Courier'},
            {name:'Verdana', css:'Verdana'}, 
            {name:'Georgia', css:'Georgia'}, 
            {name:'Palatino Linotype', css:'Palatino Linotype'},
            {name:'Garamond', css:'Garamond'}, 
            {name:'Bookman Old Style', css:'Bookman Old Style'},
            {name:'Comic Sans MS', css:'Comic Sans MS'},
            {name:'Trebuchet MS', css:'Trebuchet MS'},
            {name:'Arial Black', css:'Arial Black'}, 
            {name:'Impact', css:'Impact'},
            {name:'Calibri', css:'Calibri'}, 
            {name:'Century Gothic', css:'Century Gothic'}, 
            {name:'Sans Serif', css:'Sans Serif'},
            {name:'Sofia Pro Regular', css:'Sofia Pro Regular'}, 
            {name:'Sofia Pro Semi Bold', css:'Sofia Pro Semi Bold'}
            ]
            
        });
        taRegisterTool('fontSize', {
            display: "<span class='bar-btn-dropdown dropdown' uib-dropdown style='padding:4px 10px; z-index:3'>" +
            "<button class=' dropdown-toggle dropdown-toggle-btn' uib-dropdown-toggle type='button' ng-disabled='showHtml()'>Font-Size&nbsp;<i class='fa fa-caret-down'></i></button>" +
            "<ul class='dropdown-menu' uib-dropdown-menu aria-labelledby='dropdownMenu' style='max-height: 110px;overflow-x: scroll;'><li ng-repeat='o in options'><button class='checked-dropdown' style='font-size: {{o.css}}; width: 100%' type='button' ng-click='action($event, o.value)'><i ng-if='o.active' class='fa fa-check'></i> {{o.name}}</button></li></ul>" +
            "</span>",
            action: function (event, size) {
                //Ask if event is really an event.
                if (!!event.stopPropagation) {
                    //With this, you stop the event of textAngular.
                    event.stopPropagation();
                    //Then click in the body to close the dropdown.
                    $("body").trigger("click");
                }
                return this.$editor().wrapSelection('fontSize', parseInt(size));
            },
            options: [
                { name: '1 (8pt)', css: 'xx-small', value: 1 },
                { name: '2 (10pt)', css: 'x-small', value: 2 },
                { name: '3 (12pt)', css: 'small', value: 3 },
                { name: '4 (14pt)', css: 'medium', value: 4 },
                { name: '5 (18pt)', css: 'large', value: 5 },
                { name: '6 (24pt)', css: 'x-large', value: 6 },
                { name: '7 (30pt)', css: 'xx-large', value: 7 }
            ]
        });

        // add the button to the default toolbar definition
        taOptions.toolbar[1].push('backgroundColor', 'fontColor','fontName','fontSize');
        return taOptions;
    }]);
    (<any>window).intercomSettings = {
        app_id: (<any>window).GLOBALS && (<any>window).GLOBALS.intercomAppId,
        created_at: "1611146676893"
    };
}



// WEBPACK FOOTER //
// ./client/app/app.config.ts